<div
  class="avatar avatar--size-{{ size }}"
  [ngClass]="class"
  title="{{ firstName }} {{ lastName }}"
  [disableTooltip]="disableTooltip"
  [ngbTooltip]="toolTip"
  [placement]="toolTipPosition">
  @if (type === 'profile') {
    @if (imageUrl) {
      <div
        class="avatar__profile-image"
        [appBackgroundImage]="imageUrl"></div>
    } @else {
      @if (firstName) {
        <div
          class="avatar__initials"
          [ngClass]="initialsColorClass">
          @if (firstName) {
            <ng-container *ngTemplateOutlet="initials"></ng-container>
          }
        </div>
      } @else {
        <div class="avatar__icon">
          <i class="{{ iconClass }}"></i>
        </div>
      }
    }
  }

  @if (type === 'logo') {
    @if (imageUrl) {
      <div
        class="avatar__logo"
        [appBackgroundImage]="imageUrl"></div>
    } @else {
      @if (firstName) {
        <div
          class="avatar__initials"
          [ngClass]="initialsColorClass">
          @if (firstName) {
            <ng-container *ngTemplateOutlet="initials"></ng-container>
          }
        </div>
      } @else {
        <div class="avatar__icon">
          <i class="{{ iconClass }}"></i>
        </div>
      }
    }
  }

  @if (type === 'initials' && imageUrl !== 'undefined') {
    <div
      class="avatar__initials"
      [ngClass]="initialsColorClass">
      @if (firstName) {
        <ng-container *ngTemplateOutlet="initials"></ng-container>
      }
    </div>
  }
</div>

<ng-template #initials>
  <div class="avatar__initials-letter">
    <!-- dont break this line -->
    {{ firstName | firstLetter | emptyIndicator }}{{ lastName | firstLetter }}
  </div>
</ng-template>
